import React, { ReactElement } from "react";
import styled from "styled-components";
import { appVersion } from "utils/appVersion";

/** Small, muted version label in the corner of the header. */
export default function AppVersion(): ReactElement {
  const { version, commit, buildDate } = appVersion;
  const built = new Date(buildDate).toLocaleString();

  return (
    <Version
      data-testid="app-version"
      title={`Version ${version} · build ${commit} · ${built}`}
    >
      v{version}
    </Version>
  );
}

const Version = styled.span`
  && {
    position: absolute;
    right: 4px;
    bottom: 4px;
    margin: 0;
    font-size: 11px;
    line-height: 1;
    letter-spacing: 0.3px;
    color: #8a949e;
    user-select: text;
    cursor: default;
  }
`;
